module.exports = __webpack_public_path__ + "assets/img/effective2.826b1689.png";